import { useState } from 'react'
import type { FundSummary } from '../lib/api'

interface Props {
  funds: FundSummary[]
}

export default function SupportedFunds({ funds }: Props) {
  const [open, setOpen] = useState(false)

  if (funds.length === 0) return null

  return (
    <div className="supported-funds">
      <button
        type="button"
        className="supported-funds-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>Supported funds ({funds.length})</span>
        <span className="supported-funds-chevron">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <ul className="supported-funds-list">
          {funds.map((f) => (
            <li key={f.isin}>
              <span className="fund-ticker">{f.ticker}</span>
              <span className="fund-name">{f.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
